<template>
    <cmpTableWithMenu v-bind:name="name"
                      v-bind:pkColumn="pkColumn"
                      v-bind:fields="fields"
                      v-bind:qryFields="qryFields"
                      v-bind:children="children"
                      v-bind:parent="parent"
                      v-bind:header="header"
                      v-bind:tableFuncs="tableFuncs"
                      v-bind:moreTableFuncs="moreTableFuncs"></cmpTableWithMenu>
</template>

<script>
    import i18n from '@/i18n'
    import cmpTableWithMenu from "@/components/common/cmpTableWithMenu"

    export default {
        components: {
            cmpTableWithMenu
        },
        computed: {
            fields() {
                return [
                    { "key": "Operation", "label": i18n.t('component.operation'), tdClass: 'text-center', thClass: 'text-center' },
                    { "key": "No", "label": "No." },
                    { "key": "RoleId", "label": i18n.t('component.Privilege.RoleId.label'), sortable: true },
                    { "key": "RoleName", "label": i18n.t('component.Privilege.RoleName.label'), sortable: true },
                    { "key": "ObjectName", "label": i18n.t('component.Privilege.ObjectName.label'), sortable: true },
                    { "key": "ObjectId", "label": i18n.t('component.Privilege.ObjectId.label'), sortable: true },
                    { "key": "RightCreate", "label": i18n.t('component.Privilege.RightCreate.label'), type: "checkbox", sortable: true },
                    { "key": "RightUpdate", "label": i18n.t('component.Privilege.RightUpdate.label'), type: "checkbox", sortable: true },
                    { "key": "RightDelete", "label": i18n.t('component.Privilege.RightDelete.label'), type: "checkbox", sortable: true },
                    { "key": "RightRead", "label": i18n.t('component.Privilege.RightRead.label'), type: "checkbox", sortable: true },
                    { "key": "RightImport", "label": i18n.t('component.Privilege.RightImport.label'), type: "checkbox", sortable: true },
                    { "key": "RightExport", "label": i18n.t('component.Privilege.RightExport.label'), type: "checkbox", sortable: true },
                    { "key": "RightPrint", "label": i18n.t('component.Privilege.RightPrint.label'), type: "checkbox", sortable: true }
                ]
            },
            qryFields() {
                return [
                    { "key": "RoleId", "label": i18n.t('component.Privilege.RoleId.label'), input: { type: "select", objectName: "Role", idField: "RoleId", displayField: "RoleName" } },
                    { "key": "ObjectId", "label": i18n.t('component.Privilege.ObjectId.label'), input: { type: "text" } },
                    { "key": "ObjectName", "label": i18n.t('component.Privilege.ObjectName.label'), input: { type: "text" } }
                ]
            }
            ,
            header() {
                return i18n.t('component.Privilege.lstHeader')
            }
        },
        data() {

            return {
                name: "Privilege",
                pkColumn: "PrivilegeId",
                children: {},
                parent: {},
                tableFuncs: ['rec', 'copyNew', 'edit', 'delete'],
                moreTableFuncs: []
            };
        }
    }
</script>